export const localMode = process.env.REACT_APP_CYPRESS_AUTH === "LOCAL_AUTH";
export const simulatedAuth = localMode;
